import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formata e limita o número de telefone brasileiro
 * Aceita apenas 10-11 dígitos (com DDD)
 * Formatos: (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
 *
 * É a máscara de todos os campos de telefone: aplicada a cada tecla e ao
 * mostrar um valor salvo. Cada formulário decide se envia o valor mascarado
 * ou só os dígitos — a máscara não muda o que vai para o serviço.
 */
export function formatPhoneNumber(value: string): string {
  // Remove tudo que não é número
  let digits = value.replace(/\D/g, '');

  // Colado com o código do país (+55 11 91234-5678, 5511912345678): descarta o 55.
  // Só quando o valor não veio da própria máscara, que começa com "(" — senão quem
  // é do DDD 55 e digitasse além do limite perderia o DDD.
  if (digits.length > 11 && digits.startsWith('55') && !value.trimStart().startsWith('(')) {
    digits = digits.slice(2);
  }

  // Limita a 11 dígitos
  const limited = digits.slice(0, 11);
  
  // Aplica a máscara
  if (limited.length <= 2) {
    return limited;
  } else if (limited.length <= 6) {
    return `(${limited.slice(0, 2)}) ${limited.slice(2)}`;
  } else if (limited.length <= 10) {
    return `(${limited.slice(0, 2)}) ${limited.slice(2, 6)}-${limited.slice(6)}`;
  } else {
    return `(${limited.slice(0, 2)}) ${limited.slice(2, 7)}-${limited.slice(7, 11)}`;
  }
}
